import(/* webpackMode: "eager", webpackExports: ["OrchantaMark"] */ "/vercel/path0/apps/web/components/orchanta-mark.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.19_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/app-dir/link.js");
